// extracted by mini-css-extract-plugin
export default {"scrollToTop":"scrollToTop_scrollToTop__xmo6g","creationButton":"scrollToTop_creationButton__uIHhF"};